// src/pages/Consignacion/Consignacion.js
//
// Contenedor de la sección de consignación. Cada solapa trae sus propios datos:
// no comparten estado ni se recargan entre sí.
//
//   Reposición → qué hay que comprarle a cada proveedor (la pantalla original)
//   Reclamos   → lo ya comprado que el proveedor todavía no entregó
//   Informe    → análisis del stock en consignación (a definir)
//   Stock mín.  → el mínimo y el máximo de cada artículo, y su historial
//   Precios    → carga masiva del precio de la lista de consignación
//
// El mismo patrón que el Dashboard: el contenedor tiene el título y la
// navegación, y cada solapa se monta sólo cuando está activa.
import React, { useState } from 'react';
import TabReposicion from './Tabs/TabReposicion';
import TabReclamos from './Tabs/TabReclamos';
import TabInforme from './Tabs/TabInforme';
import TabStockMinimo from './Tabs/TabStockMinimo';
import TabPrecios from './Tabs/TabPrecios';
import './Consignacion.css';

const SOLAPAS = [
  { id: 'reposicion', titulo: 'Reposición', icono: 'bi-cart-plus' },
  { id: 'reclamos',   titulo: 'Reclamos',   icono: 'bi-envelope-exclamation' },
  { id: 'informe',    titulo: 'Informe',    icono: 'bi-graph-up' },
  { id: 'minimos',    titulo: 'Stock mín. y máx.', icono: 'bi-sliders' },
  { id: 'precios',    titulo: 'Precios',   icono: 'bi-tags' }
];

const Consignacion = () => {
  const [solapa, setSolapa] = useState('reposicion');

  return (
    <div className="container-fluid">
      <h1 className="mt-4 mb-0">
        <i className="bi bi-box-seam me-2"></i>
        Stock en Consignación
      </h1>

      <ul className="nav nav-tabs mt-3">
        {SOLAPAS.map(s => (
          <li className="nav-item" key={s.id}>
            <button
              className={`nav-link ${solapa === s.id ? 'active' : ''}`}
              onClick={() => setSolapa(s.id)}
              type="button"
            >
              <i className={`bi ${s.icono} me-1`}></i>
              {s.titulo}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content">
        {/* Montaje condicional: cada solapa consulta SAP al montarse, así que
            renderizar las tres dispararía tres consultas por visita. */}
        {solapa === 'reposicion' && <TabReposicion />}
        {solapa === 'reclamos'   && <TabReclamos />}
        {solapa === 'informe'    && <TabInforme />}
        {solapa === 'minimos'    && <TabStockMinimo />}
        {solapa === 'precios'    && <TabPrecios />}
      </div>
    </div>
  );
};

export default Consignacion;
